import type { Question } from "../../data/assessmentData";

// TODO: Translate all question text and option text to Dutch
// Structure must be identical to assessmentData.ts (same ids, same levels, same correctAnswer)
export const assessmentQuestionsNl: Question[] = [
  // Strategie & Sturing (5 vragen)
  {
    id: 1,
    pillar: "Strategie & Sturing",
    question: "Is uw positionering duidelijk?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Als u de vraag aan drie mensen intern stelt, krijgt u vier verschillende antwoorden.",
      },
      {
        id: "b",
        level: 2,
        text: "Er is een **algemeen idee**, maar iedereen formuleert het op zijn eigen manier. De website zegt één ding, de verkopers een ander.",
      },
      {
        id: "c",
        level: 3,
        text: "De positionering is **gedefinieerd en gedocumenteerd**. Het team kent het, maar het wordt niet altijd in elk medium uitgewerkt.",
      },
      {
        id: "d",
        level: 4,
        text: "Positionering **duidelijk, intern gedeeld** en overal weerspiegeld. Klanten bevestigen het spontaan.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 2,
    pillar: "Strategie & Sturing",
    question: "Is uw acquisitiestrategie gestructureerd?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Onze acquisitiestrategie bestaat uit mond-tot-mondreclame en de hoop dat de telefoon rinkelt.",
      },
      {
        id: "b",
        level: 2,
        text: "We ondernemen **incidentele acties** (beurs, LinkedIn-campagne) maar zonder globaal plan of duidelijke doelstellingen.",
      },
      {
        id: "c",
        level: 3,
        text: "Er bestaat een plan met **geïdentificeerde kanalen**, een budget en terugkerende campagnes. Resultaten worden gevolgd, maar **niet gekoppeld aan de pipeline**.",
      },
      {
        id: "d",
        level: 4,
        text: "**Gedocumenteerde strategie** per kanaal, met kwantitatieve doelstellingen, budget, actieve campagnes en maandelijkse opvolging **gekoppeld aan de pipeline**.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 3,
    pillar: "Strategie & Sturing",
    question: "Hoe verloopt de samenwerking tussen marketing en verkoop?",
    options: [
      {
        id: "a",
        level: 1,
        text: "De verkoop zegt dat de leads slecht zijn. Marketing zegt dat de verkopers niet terugbellen. Het is ingewikkeld.",
      },
      {
        id: "b",
        level: 2,
        text: "We wisselen **af en toe** informatie uit, maar marketing weet niet altijd wat de verkopers doen met de leads, en omgekeerd.",
      },
      {
        id: "c",
        level: 3,
        text: "**Regelmatige vergaderingen** en een gemeenschappelijke definitie van een goede lead. Maar tools en gegevens worden nog niet gedeeld.",
      },
      {
        id: "d",
        level: 4,
        text: "Gemeenschappelijk CRM, regelmatige vergaderingen, gedeelde rapportage. Beide teams **werken met dezelfde KPI's**.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 4,
    pillar: "Strategie & Sturing",
    question:
      "Hoe beslist u wat prioriteit heeft in marketing als alles dringend lijkt?",
    options: [
      {
        id: "a",
        level: 1,
        text: "De prioriteit is wat de CEO vanmorgen bij een concurrent zag, of wat de meest vocale verkoper vraagt.",
      },
      {
        id: "b",
        level: 2,
        text: "We hebben een idee van de prioriteiten, maar ze **veranderen vaak** naargelang de urgentie en interne verzoeken.",
      },
      {
        id: "c",
        level: 3,
        text: "Prioriteiten **vastgesteld aan het begin van het kwartaal**. Aanpassingen worden gemaakt, maar de koers blijft duidelijk.",
      },
      {
        id: "d",
        level: 4,
        text: "Prioritering op objectieve criteria (impact, inspanning, strategische afstemming). **Kwartaalplan herzien** met het management.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 5,
    pillar: "Strategie & Sturing",
    question:
      "Heeft u dashboards die de prestaties van uw marketingacties in één oogopslag tonen?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Ons dashboard is een algemeen gevoel en een blik op Google Analytics eens per kwartaal.",
      },
      {
        id: "b",
        level: 2,
        text: "We kijken naar de statistieken van elk hulpmiddel afzonderlijk (Analytics, LinkedIn, e-mailing) maar **zonder geconsolideerd overzicht**.",
      },
      {
        id: "c",
        level: 3,
        text: "Een dashboard groepeert de **belangrijkste KPI's**. Het wordt regelmatig geraadpleegd maar handmatig bijgewerkt.",
      },
      {
        id: "d",
        level: 4,
        text: "**Geautomatiseerd dashboard** dat alle bronnen groepeert, elke week geraadpleegd en gebruikt om beslissingen te sturen.",
      },
    ],
    correctAnswer: "d",
  },

  // Merk & Ervaring (6 vragen)
  {
    id: 6,
    pillar: "Merk & Ervaring",
    question:
      "Is uw imago consistent en herkenbaar op uw website, drukwerk en sociale media?",
    options: [
      {
        id: "a",
        level: 1,
        text: "We hebben een logo. Eigenlijk drie. Plus het logo dat iemand in PowerPoint heeft nagemaakt voor een beurs.",
      },
      {
        id: "b",
        level: 2,
        text: "We hebben een logo en gedefinieerde kleuren, maar **iedereen knoeit** met zijn eigen presentaties en visuals.",
      },
      {
        id: "c",
        level: 3,
        text: "Er bestaat een **huisstijlgids** en de meeste media respecteren die. Er blijven nog enkele afwijkingen (oude documenten, niet-bijgewerkte sjablonen).",
      },
      {
        id: "d",
        level: 4,
        text: "Complete huisstijl **overal toegepast**: website, sociale media, presentaties, handtekeningen, drukwerk. Elk medium versterkt het merk.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 7,
    pillar: "Merk & Ervaring",
    question:
      "Helpen uw marketingmaterialen (brochures, presentaties, productfiches) uw verkopers om te verkopen?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Onze verkopers maken hun eigen PowerPoint voor elke vergadering. Niemand gebruikt dezelfde documenten.",
      },
      {
        id: "b",
        level: 2,
        text: "Er zijn materialen, maar ze zijn **verouderd** of komen niet meer overeen met wat we werkelijk verkopen.",
      },
      {
        id: "c",
        level: 3,
        text: "De materialen zijn **up-to-date en in gebruik**. Ze zouden impactvoller kunnen zijn of beter aangepast aan bepaalde doelgroepen.",
      },
      {
        id: "d",
        level: 4,
        text: "De materialen zijn uitgewerkt per doelgroep en per fase van de verkoopcyclus en ze **converteren**.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 8,
    pillar: "Merk & Ervaring",
    question:
      "Begrijpt een bezoeker op uw website in enkele seconden wat u doet?",
    options: [
      {
        id: "a",
        level: 1,
        text: 'Onze homepage zegt "Innovatieve oplossingen voor een bewegende wereld". Niemand weet wat dat betekent.',
      },
      {
        id: "b",
        level: 2,
        text: "De website legt onze diensten uit, maar **men moet zoeken** om concreet te begrijpen wat we doen.",
      },
      {
        id: "c",
        level: 3,
        text: "De **boodschap is duidelijk**, maar het parcours zou bezoekers beter kunnen begeleiden naar een concrete actie.",
      },
      {
        id: "d",
        level: 4,
        text: "Duidelijke boodschap vanaf de homepage, **parcours uitgedacht** per doelgroep, call-to-actions die converteren.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 9,
    pillar: "Merk & Ervaring",
    question: "Gebruikt u een CRM om uw prospects en klanten op te volgen?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Ons CRM is een Excel-bestand dat niemand bijwerkt en waarvan er 4 versies op de server bestaan.",
      },
      {
        id: "b",
        level: 2,
        text: "We hebben een **CRM**, maar slechts een deel van het team gebruikt het. De gegevens zijn **niet up-to-date**.",
      },
      {
        id: "c",
        level: 3,
        text: "Het CRM wordt **door een deel van het team gebruikt**. Marketing en verkoop werken er niet echt samen in.",
      },
      {
        id: "d",
        level: 4,
        text: "**Gecentraliseerd CRM, gebruikt** door zowel verkoop ALS marketing. Contacten gesegmenteerd, volledige geschiedenis, betrouwbare gegevens.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 10,
    pillar: "Merk & Ervaring",
    question:
      "Communiceren uw marketingtools (website, e-mailing, CRM, analytics) met elkaar?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Om te weten wat er gebeurt, hebt u zes wachtwoorden, vier tabbladen en een talent voor kopiëren-plakken nodig.",
      },
      {
        id: "b",
        level: 2,
        text: "Sommige verbindingen bestaan (websiteformulier → CRM) maar **veel gebeurt handmatig**.",
      },
      {
        id: "c",
        level: 3,
        text: "De **belangrijkste tools** zijn **verbonden** maar sommige gegevens moeten handmatig worden geëxporteerd/geïmporteerd.",
      },
      {
        id: "d",
        level: 4,
        text: "Geïntegreerd ecosysteem: website, CRM, e-mailing en analytics communiceren **automatisch**.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 11,
    pillar: "Merk & Ervaring",
    question: "Is uw website technisch performant?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Onze website laadt zo langzaam dat u tijd heeft om koffie te zetten terwijl u wacht. Op mobiel is het nog erger.",
      },
      {
        id: "b",
        level: 2,
        text: "De website werkt over het algemeen, maar **we meten** de laadsnelheid of SEO-scores niet.",
      },
      {
        id: "c",
        level: 3,
        text: "De website is **technisch correct** en mobielklaar. Snelheid en technische SEO kunnen worden verbeterd.",
      },
      {
        id: "d",
        level: 4,
        text: "Snelle website, mobile-first, geoptimaliseerde technische SEO, met **regelmatige prestatiemonitoring**.",
      },
    ],
    correctAnswer: "d",
  },

  // Content & Zichtbaarheid (6 vragen)
  {
    id: 12,
    pillar: "Content & Zichtbaarheid",
    question:
      "Produceert u regelmatig content (artikelen, LinkedIn-posts, video's, casestudies, ...) om uw prospects aan te trekken?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Ons laatste blogartikel dateert van 2019. Het gaat over Covid. Sindsdien is het radiostilte.",
      },
      {
        id: "b",
        level: 2,
        text: "We publiceren **af en toe**, wanneer iemand tijd of inspiratie heeft. Geen ritme of redactioneel plan.",
      },
      {
        id: "c",
        level: 3,
        text: "Er bestaat een redactionele kalender en **we publiceren regelmatig**. De content zou gerichter kunnen zijn.",
      },
      {
        id: "d",
        level: 4,
        text: "**Geïndustrialiseerde productie**: redactionele kalender, gevarieerde formats, regelmatige publicatie.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 13,
    pillar: "Content & Zichtbaarheid",
    question:
      "Richt uw content zich tot een specifieke doelgroep of spreekt u tot iedereen?",
    options: [
      { id: "a", level: 1, text: "Wij richten ons tot iedereen." },
      {
        id: "b",
        level: 2,
        text: "De content is **niet aangepast aan specifieke profielen**.",
      },
      {
        id: "c",
        level: 3,
        text: "De meeste content is **bedacht voor onze belangrijkste doelgroepen**.",
      },
      {
        id: "d",
        level: 4,
        text: "Content aangepast aan **elk profiel** en **elke fase** van het aankooptraject.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 14,
    pillar: "Content & Zichtbaarheid",
    question: "Onderscheidt uw content zich van die van uw concurrenten?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Als we het logo van een concurrent op onze content zetten, ziet eerlijk gezegd niemand het verschil.",
      },
      {
        id: "b",
        level: 2,
        text: "We hebben eigen content, maar de toon en onderwerpen **lijken op wat anderen** in de sector doen.",
      },
      {
        id: "c",
        level: 3,
        text: "Onze content heeft een **gedefinieerde identiteit** (toon, onderwerpen, invalshoek). Onze uitdaging is consistentie op alle kanalen.",
      },
      {
        id: "d",
        level: 4,
        text: "Onderscheidende stem, gevarieerde formats, identificeerbare redactionele lijn **op alle communicatiekanalen**.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 15,
    pillar: "Content & Zichtbaarheid",
    question: "Hoe distribueert u uw content?",
    options: [
      {
        id: "a",
        level: 1,
        text: "We publiceren een artikel op de website en hopen dat iemand het vindt.",
      },
      {
        id: "b",
        level: 2,
        text: "We verspreiden via **enkele kanalen** (LinkedIn, nieuwsbrief) maar zonder gestructureerd plan of hergebruik.",
      },
      {
        id: "c",
        level: 3,
        text: "Er bestaat een **verspreidingsplan**: elke content wordt via meerdere kanalen verspreid met een kalender. We beginnen te hergebruiken.",
      },
      {
        id: "d",
        level: 4,
        text: "**Gecoördineerde distributie**: elk kanaal heeft een gedefinieerde rol (bekendheid, acquisitie, nurturing).",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 16,
    pillar: "Content & Zichtbaarheid",
    question:
      "Bent u zichtbaar en actief op de kanalen waar uw klanten zich bevinden?",
    options: [
      {
        id: "a",
        level: 1,
        text: "We hebben in 2020 een LinkedIn-pagina aangemaakt. Ze heeft ons logo en een beschrijving. Sindsdien niets.",
      },
      {
        id: "b",
        level: 2,
        text: "We zijn vindbaar **op enkele kanalen** maar zonder dat dit het resultaat is van een gestructureerde inspanning.",
      },
      {
        id: "c",
        level: 3,
        text: "**Zichtbare aanwezigheid op onze belangrijkste kanalen** dankzij regelmatige content.",
      },
      {
        id: "d",
        level: 4,
        text: "**Gecoördineerde multikanalenstrategie** die gekwalificeerde leads aantrekt.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 17,
    pillar: "Content & Zichtbaarheid",
    question: "Vinden uw klanten u wanneer ze zoeken naar uw diensten?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Als we de naam van onze hoofddienst op Google typen, komen we uit bij concurrenten. Om ons te vinden, moet men onze exacte naam typen.",
      },
      {
        id: "b",
        level: 2,
        text: "We hebben **basisoptimalisaties** gedaan voor Google (titels, trefwoorden) maar zonder gestructureerde SEO-strategie.",
      },
      {
        id: "c",
        level: 3,
        text: "**SEO wordt in acht genomen**: trefwoorden geïdentificeerd, geoptimaliseerde content, positionering gevolgd. Een systematische aanpak ontbreekt.",
      },
      {
        id: "d",
        level: 4,
        text: "**Volledige SEO-strategie** om ons te vinden op Google, maar ook in AI-tools zoals ChatGPT.",
      },
    ],
    correctAnswer: "d",
  },

  // AI & Tools (6 vragen)
  {
    id: 18,
    pillar: "AI & Tools",
    question: "Hoe beheert u uw marketingprojecten?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Ons projectbeheersinstrument is een volle e-mailbox en post-its op het scherm. Soms een gedeeld Excel-bestand.",
      },
      {
        id: "b",
        level: 2,
        text: "We hebben een tool (Trello, Excel…) maar die wordt **niet systematisch gebruikt** door het hele team.",
      },
      {
        id: "c",
        level: 3,
        text: "Een **projectbeheertool** is aanwezig en **in gebruik**. Taken opgevolgd, deadlines **over het algemeen gehaald**.",
      },
      {
        id: "d",
        level: 4,
        text: "**Gestructureerd beheer** (Kanban of sprints), teamrituelen, duidelijke prioriteiten, **wekelijkse opvolging**.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 19,
    pillar: "AI & Tools",
    question: "Meet u de ROI van uw marketing?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Geen idee. Marketing is een daad van geloof. We investeren en hopen dat het werkt.",
      },
      {
        id: "b",
        level: 2,
        text: "We hebben een **algemeen idee van de kosten**, maar een investering koppelen aan een concreet bedrijfsresultaat blijft moeilijk.",
      },
      {
        id: "c",
        level: 3,
        text: "**ROI wordt gemeten voor de belangrijkste acties** (campagnes, beurzen). Een geconsolideerd overzicht dat uitgaven en pipeline koppelt ontbreekt.",
      },
      {
        id: "d",
        level: 4,
        text: "**ROI** gemeten per kanaal, gekoppeld aan bedrijfsresultaten (leads, afspraken, contracten) en **geconsolideerd in een dashboard**.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 20,
    pillar: "AI & Tools",
    question:
      "Gebruikt u AI in uw marketingactiviteiten: redactie, analyse, visuals, automatisering?",
    options: [
      {
        id: "a",
        level: 1,
        text: "AI? We hebben ChatGPT een keer gevraagd een e-mail te schrijven. Telt dat?",
      },
      {
        id: "b",
        level: 2,
        text: "Sommige mensen gebruiken AI-tools **sporadisch** (ChatGPT, Copilot), maar zonder kader of kennisdeling.",
      },
      {
        id: "c",
        level: 3,
        text: "AI-tools zijn **geïntegreerd in bepaalde marketingprocessen** (redactie, analyse, visuals). Het gebruik is omlijnd maar niet systematisch.",
      },
      {
        id: "d",
        level: 4,
        text: "**AI strategisch ingezet**: geïntegreerde tools, gedocumenteerde prompts, gemeten voordelen.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 21,
    pillar: "AI & Tools",
    question:
      "Is uw team opgeleid in AI, of doet iedereen het op zijn eigen manier?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Het team opleiden? We wachten tot de stagiair ons laat zien hoe het werkt.",
      },
      {
        id: "b",
        level: 2,
        text: "**Enkele mensen experimenteren**, maar er is geen gestructureerd delen van learnings of best practices.",
      },
      {
        id: "c",
        level: 3,
        text: "Er hebben trainingen of workshops plaatsgevonden. **Het team kent de basis**, maar de adoptie is ongelijk.",
      },
      {
        id: "d",
        level: 4,
        text: "**Doorlopende opleiding**, **gedeelde** best practices, actieve monitoring. AI maakt deel uit van de teamcultuur.",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 22,
    pillar: "AI & Tools",
    question: "Bespaart AI u werkelijk tijd of geld, op meetbare wijze?",
    options: [
      {
        id: "a",
        level: 1,
        text: "We weten niet of AI ons tijd bespaart. We besteden zoveel tijd aan het corrigeren van de outputs dat de vraag zich stelt.",
      },
      {
        id: "b",
        level: 2,
        text: "**Incidentele winsten** (snellere redactie, ideeën voor content), maar niets formeel gemeten.",
      },
      {
        id: "c",
        level: 3,
        text: "Winsten worden geïdentificeerd en erkend (productiviteit, kwaliteit). **We beginnen ze te kwantificeren.**",
      },
      {
        id: "d",
        level: 4,
        text: "Impact = gewonnen tijd per proces, verlaagde kosten per deliverable, verbeterde kwaliteit. **De cijfers rechtvaardigen de investering.**",
      },
    ],
    correctAnswer: "d",
  },
  {
    id: 23,
    pillar: "AI & Tools",
    question: "Heeft u duidelijke regels over het gebruik van AI?",
    options: [
      {
        id: "a",
        level: 1,
        text: "Regels? We hebben niet eens duidelijke regels voor het gebruik van het koffiezetapparaat.",
      },
      {
        id: "b",
        level: 2,
        text: "**Het is impliciet**: we weten dat we geen vertrouwelijke gegevens mogen delen, maar niets staat op papier.",
      },
      {
        id: "c",
        level: 3,
        text: "**Er bestaan richtlijnen** (toegestane gegevens, vereiste menselijke validatie). Gecommuniceerd maar niet altijd toegepast.",
      },
      {
        id: "d",
        level: 4,
        text: "**Gedocumenteerd en toegepast AI-beleid**: toegestane gegevens, validatieprocessen, GDPR-naleving, regelmatige herziening.",
      },
    ],
    correctAnswer: "d",
  },
];
